// extracted by mini-css-extract-plugin
module.exports = {"dot":"DotIndicator_dot__5KrEe","dot--inverse":"DotIndicator_dot--inverse__WxGHn"};